import React from "react";

import styles from "./Highlight.module.scss";

export default function Highlight({title, source, text, classname, color = 'white', font, children}) {
    const style = window.getComputedStyle(document.querySelector('body'));

    return (
        <div className={[styles.Main, classname ?? ''].join(' ')} style={{
            color: font ? style.getPropertyValue(`--${font}`) : style.getPropertyValue(`--${color}BGFont`)
        }}>

            <div className={styles.Background} style={{
                backgroundColor: style.getPropertyValue(`--${color}BG`),
            }}/>

            {
                title || source || text ?
                    <div className={styles.TableText}>
                        <div>
                            <h4 dangerouslySetInnerHTML={{__html: title}}/>

                            {
                                source ?
                                    <span className={styles.Source} dangerouslySetInnerHTML={{__html: source}}/>
                                    : null
                            }
                        </div>

                        {
                            text ? <p className={'italic'} dangerouslySetInnerHTML={{__html: text}}/> : null
                        }
                    </div>
                    : null
            }


            { children }

        </div>
    )
}
